export default __webpack_public_path__ + "media/images/halloween/starfield-040a28898cdb8593433f977123fc7834.png";